export class FullReviewCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: instance => {
          const currentSlide =
            instance.slides[instance.track.details.abs % instance.slides.length]

          if (currentSlide.dataset.backgroundColour) {
            this.style.setProperty(
              '--Background_Colour',
              currentSlide.dataset.backgroundColour,
            )
          }

          if (currentSlide.dataset.textColour) {
            this.style.setProperty(
              '--Text_Colour',
              currentSlide.dataset.textColour,
            )
          }
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els.dot.elements),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('full-review-carousel')) {
  customElements.define('full-review-carousel', FullReviewCarousel)
}
